const DEFAULT_CALCOM_BASE_URL =
  "https://cal.com/team/bookkeepie-magyarorszag";

export const createCalComUrl = ({
  reqId,
  compCtcName,
  compEmail,
  compPhone,
  baseUrl,
}) => {
  if (!reqId) {
    return null;
  }

  const companyctcname = encodeURIComponent(compCtcName);
  const email = encodeURIComponent(compEmail);
  let companyPhone = String(compPhone || "").trim();

  if (!companyPhone.startsWith("+")) {
    if (companyPhone.startsWith("36")) {
      companyPhone = `+${companyPhone}`;
    } else {
      companyPhone = `+36${companyPhone}`;
    }
  }

  const location = encodeURIComponent(
    `{"value":"phone","optionValue":"${companyPhone}"}`,
  );

  const metadata = encodeURIComponent(
    JSON.stringify({
      reqID: reqId,
      name: companyctcname,
      email,
      phone: companyPhone,
    }),
  );

  const root = (baseUrl || DEFAULT_CALCOM_BASE_URL).trim();
  const separator = root.includes("?") ? "&" : "?";

  return `${root}${separator}reqID=${reqId}&name=${companyctcname}&email=${email}&location=${location}&metadata=${metadata}`;
};

export const navigateToUrl = (url) => {
  window.location.href = url;
};
